var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "file_dark",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_46127",
    "data-name": "Path 46127",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46128",
    "data-name": "Path 46128",
    d: "M17.5,4.5A9.3,9.3,0,0,0,12,6,9.3,9.3,0,0,0,6.5,4.5a10.819,10.819,0,0,0-4.28.79A2.037,2.037,0,0,0,1,7.14V18.42a2,2,0,0,0,2.48,1.94A12.35,12.35,0,0,1,6.5,20a10.574,10.574,0,0,1,4.56.92,2.055,2.055,0,0,0,1.87,0A10.43,10.43,0,0,1,17.49,20a12.35,12.35,0,0,1,3.02.36,1.986,1.986,0,0,0,2.48-1.94V7.14a2.037,2.037,0,0,0-1.22-1.85A10.738,10.738,0,0,0,17.5,4.5ZM21,17.23a1.01,1.01,0,0,1-1.2.98,12.609,12.609,0,0,0-2.3-.2,12.045,12.045,0,0,0-5.5,1.5V8a12.045,12.045,0,0,1,5.5-1.5,12.687,12.687,0,0,1,2.7.28,1.014,1.014,0,0,1,.8.98Z",
    fill: "#374955"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDark);
export default __webpack_public_path__ + "static/media/file_dark.cdb5cceaa48bd15bde4957b07fa87951.svg";
export { ForwardRef as ReactComponent };